import { put, takeEvery, call } from 'redux-saga/effects'
import cookie from 'react-cookie'
import { api } from '../services/api'
import {
  INIT_ADD_FREE_PAYMENT,
  INIT_ADD_FREE_PAYMENT_FAIL,
  INIT_ADD_FREE_PAYMENT_SUCCESS,
  INIT_BRAINTREE_3DSECURE,
  INIT_BRAINTREE_3DSECURE_FAIL,
  INIT_BRAINTREE_3DSECURE_SUCCESS,
  INIT_BRAINTREE_CLIENT,
  INIT_BRAINTREE_CLIENT_FAIL,
  INIT_BRAINTREE_CLIENT_SUCCESS,
  INIT_BRAINTREE_HOSTEDFIELDS,
  INIT_BRAINTREE_HOSTEDFIELDS_FAIL,
  INIT_BRAINTREE_HOSTEDFIELDS_SUCCESS,
  INIT_PAYMENT_GATEWAY,
  INIT_PAYMENT_GATEWAY_FAIL,
  INIT_PAYMENT_GATEWAY_SUCCESS,
  USER_PAYMENT_PROCESSING
} from '../actions/index'

function* onInitPaymentGateway() {
  try {
    const paymentGatewayInfo = yield call(api.initPaymentGateway)
    yield put({ type: INIT_PAYMENT_GATEWAY_SUCCESS, payload: paymentGatewayInfo })
  } catch (e) {
    yield put({ type: INIT_PAYMENT_GATEWAY_FAIL, payload: e.message })
  }
}

function* onInitAdFreePayment({payload}) {
  try {
    const adFreePayment = yield call(api.payAdFreeSubscription, payload)
    yield put({ type: INIT_ADD_FREE_PAYMENT_SUCCESS, payload: {
      error: false,
      errorMessage: ''
    } })
  } catch (e) {
    yield put({ type: INIT_ADD_FREE_PAYMENT_FAIL, payload: {
      error: true,
      errorMessage: e.message
    } })
  }
}

export function* paymentGateway() {
  yield takeEvery(INIT_PAYMENT_GATEWAY, onInitPaymentGateway)
  yield takeEvery(INIT_BRAINTREE_CLIENT, onInitBraintreeClient)
  yield takeEvery(INIT_BRAINTREE_3DSECURE, onInitBraintree3DSecure)
  yield takeEvery(INIT_BRAINTREE_HOSTEDFIELDS, onInitBraintreeHostedFields)
  yield takeEvery(INIT_ADD_FREE_PAYMENT, onInitAdFreePayment)
}

function initBraintreeClient(clientToken) {
  return new Promise((resolve, reject) => {
    window.braintree.client.create({
      authorization: clientToken
    }).then(function(clientInstance) {
      resolve(clientInstance);
    }).catch( function(err) {
      reject(err);
    });
  })
}

function initBraintree3DSecure(client) {
  return new Promise((resolve, reject) => {
    braintree.threeDSecure.create({
      version: 2,
      client
    }).then(function(threeDSecure) {
      resolve(threeDSecure)
    }).catch(function(err) {
      reject(err)
    })
  });
}

function initBraintreeHostedFields({client, clientOptions}) {
  return new Promise((resolve, reject) => {
    window.braintree.hostedFields.create({
        client,
        ...clientOptions
    }).then(function(hostedFields) {
      resolve(hostedFields)
    }).catch(function(err) {
      reject(err)
    })
  });
}

function* onInitBraintreeClient({payload}) {
  const clientToken = payload;

  try {
    const braintreeClient = yield call(initBraintreeClient, clientToken);
    yield put({ type: INIT_BRAINTREE_CLIENT_SUCCESS, payload: braintreeClient })
  } catch (e) {
    yield put({ type: INIT_BRAINTREE_CLIENT_FAIL, payload: e.message })
  }
}

function* onInitBraintree3DSecure({payload}) {
  try {
    const braintree3DSecure = yield call(initBraintree3DSecure, payload);
    yield put({ type: INIT_BRAINTREE_3DSECURE_SUCCESS, payload: braintree3DSecure })
  } catch (e) {
    yield put({ type: INIT_BRAINTREE_3DSECURE_FAIL, payload: e.message })
  }
}

function* onInitBraintreeHostedFields({payload}) {
  try {
    const hostedFields = yield call(initBraintreeHostedFields, payload);
    yield put({ type: INIT_BRAINTREE_HOSTEDFIELDS_SUCCESS, payload: hostedFields })
  } catch (e) {
    yield put({ type: INIT_BRAINTREE_HOSTEDFIELDS_FAIL, payload: e.message })
  }
}


// WEBPACK FOOTER //
// ./src/sagas/payment-gateway.js